import type { RhythmFigureId } from './rhythmTokens';

export interface RhythmFigureSpriteDef {
  src: string;
  /** Ancho / alto del PNG (para reservar espacio). */
  aspectRatio: number;
}

/** Ilustraciones de figuras rítmicas (PNG con fondo transparente). */
export const RHYTHM_FIGURE_SPRITES: Partial<Record<RhythmFigureId, RhythmFigureSpriteDef>> = {
  negra: {
    src: '/junior-assets/images/negra.png',
    aspectRatio: 1,
  },
  blanca: {
    src: '/junior-assets/images/blanca.png',
    aspectRatio: 1,
  },
  corchea_doble: {
    src: '/junior-assets/images/doble.png',
    aspectRatio: 1,
  },
  cuartina: {
    src: '/junior-assets/images/cuartina.png',
    aspectRatio: 1,
  },
};

export function rhythmFigureSprite(fig: RhythmFigureId): RhythmFigureSpriteDef | null {
  return RHYTHM_FIGURE_SPRITES[fig] ?? null;
}
